import { useState, useEffect } from "react";
import Lottie from "lottie-react";
import styles from "../styles/buildingBusiness.module.css";

import shopAnim from "../assets/lottie/building/shop.json";
import calendarAnim from "../assets/lottie/building/calendar.json";
import settingsAnim from "../assets/lottie/building/settings.json";
import designAnim from "../assets/lottie/building/design.json";

const STEPS = [
  {
    animation: shopAnim,
    text: "מכינים את הפרופיל העסקי שלך...",
    doneText: "הפרופיל העסקי מוכן",
  },
  {
    animation: calendarAnim,
    text: "בונים את מערכת ניהול התורים...",
    doneText: "מערכת התורים הוגדרה",
  },
  {
    animation: settingsAnim,
    text: "מתאימים הגדרות חכמות לעסק...",
    doneText: "ההגדרות מותאמות",
  },
  {
    animation: designAnim,
    text: "מעצבים את עמוד העסק החדש שלכם...",
    doneText: "עמוד העסק מוכן!",
  },
];

const STEP_DELAY = 1400; // ms between each step
const DONE_DELAY = 800; // ms after last step before navigating

const BuildingBusiness = ({ onNext }) => {
  const [activeStep, setActiveStep] = useState(0);
  const [completedSteps, setCompletedSteps] = useState([]);

  useEffect(() => {
    const timers = [];

    STEPS.forEach((_, i) => {
      // Mark step as completed
      timers.push(
        setTimeout(() => {
          setCompletedSteps((prev) => [...prev, i]);
          // Move to next step
          if (i < STEPS.length - 1) {
            setActiveStep(i + 1);
          }
        }, STEP_DELAY * (i + 1))
      );
    });

    // Navigate after all steps complete
    timers.push(
      setTimeout(() => {
        onNext();
      }, STEP_DELAY * STEPS.length + DONE_DELAY)
    );

    return () => timers.forEach(clearTimeout);
  }, [onNext]);

  const ownerName = localStorage.getItem("ownerName") || "";

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.heroIcon}>🚀</div>
        <h1 className={styles.title}>
          {ownerName ? `${ownerName}, ` : ""}בונים את העסק שלך
        </h1>
        <p className={styles.subtitle}>רק כמה שניות ואנחנו מסיימים...</p>

        <div className={styles.stepsContainer}>
          {STEPS.map((step, i) => {
            const isActive = activeStep === i && !completedSteps.includes(i);
            const isCompleted = completedSteps.includes(i);
            const isVisible = i <= activeStep;

            return (
              <div
                key={i}
                className={`${styles.step} ${isVisible ? styles.stepVisible : ""} ${
                  isCompleted ? styles.stepCompleted : ""
                }`}
              >
                <div className={styles.iconWrap}>
                  {isActive && (
                    <div className={styles.spinnerRing} />
                  )}
                  {isCompleted ? (
                    <div className={styles.checkCircle}>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                        <path
                          d="M20 6L9 17L4 12"
                          stroke="white"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  ) : (
                    <div className={`${styles.lottieIcon} ${isActive ? styles.lottieActive : ""}`}>
                      <Lottie
                        animationData={step.animation}
                        loop
                        autoplay
                        style={{ width: "100%", height: "100%" }}
                      />
                    </div>
                  )}
                </div>
                <span className={`${styles.stepText} ${isCompleted ? styles.stepTextDone : ""}`}>
                  {isCompleted ? step.doneText : step.text}
                </span>
              </div>
            );
          })}
        </div>

        <div className={styles.progressBar}>
          <div
            className={styles.progressFill}
            style={{
              width: `${((completedSteps.length) / STEPS.length) * 100}%`,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default BuildingBusiness;
